import styled from 'styled-components';

export const Wrapper = styled.div`
	padding-bottom: 24px;
`;

export const HelpTitle = styled.div`
	color: ${({ theme }) => theme.colors.text.body};
	font-size: 16px;
	margin-bottom: 24px;
	margin-top: 24px;
	text-align: center;
`;

export const HelpButtonWrapper = styled.div`
	align-items: center;
	border-bottom: 1px solid ${({ theme }) => theme.colors.transparent.light15};
	display: flex;
	flex-wrap: wrap;
	gap: 12px;
	justify-content: center;
	margin-bottom: 8px;
	padding-bottom: 24px;
`;

export const HelpButtonMain = styled.div<{ $type: 'telegram' | 'phone' | 'email' }>`
	align-items: center;
	background-color: ${({ $type }) => ($type === 'telegram' ? '#299FDA' : $type === 'phone' ? '#7C529E' : '#3E3C37')};
	border-radius: 11px;
	color: #ffffff;
	display: flex;
	font-size: 14px;
	gap: 4px;
	padding: 8px;
`;

export const HelpButton = styled.button`
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
	color: ${({ theme }) => theme.colors.control.primary};
	text-align: center;
	width: 100%;
`;
